<div class="_ratings-average-statistic-component">

	<p>{{'STATISTICS.RATINGS.AVERAGE' | translate}}<b>{{averageOfRatings ?? '-'}}/5</b></p>

</div>



